import useCustomLoginWithRedirect from "@/hooks/useCustomLoginWithRedirect";

interface AdminAccessDeniedProps {
    redirectPath?: string;
}

/**
 * Reusable component for showing admin access denied message
 */
const AdminAccessDenied = ({ redirectPath = "/admin" }: AdminAccessDeniedProps) => {
    const { customLoginWithRedirect } = useCustomLoginWithRedirect();

    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-p-8">
            <h2 className="tw-text-2xl tw-font-bold tw-mb-4">Access Denied</h2>
            <p className="tw-text-center tw-mb-4">
                You must be an admin to access this page. Please{" "}
                <button
                    onClick={() =>
                        customLoginWithRedirect({
                            authorizationParams: {
                                redirect_uri: window.location.origin + redirectPath,
                            },
                        })
                    }
                    className="tw-text-blue-500 tw-underline tw-bg-transparent tw-border-none tw-cursor-pointer"
                >
                    log in
                </button>{" "}
                to your admin account.
            </p>
        </div>
    );
};

export default AdminAccessDenied;
